import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';
import { getClaimKey } from '../../../../functions/get-claim-key';
import { HrDependentsResponse } from '../../../../models/api/view/claim/hr/dependents/hr-dependents-response';
import { BaseComponent } from '../../../base/base.component';
import { AddressLabelComponent } from '../../../core/labels/address-label.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { SsnLabelComponent } from '../../../core/labels/ssn-label.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-dependents',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    TableComponent,
    ColumnComponent,
    RouterModule,
    PageHeaderComponent,
    AddressLabelComponent,
    SsnLabelComponent,
  ],
  template: `
    <app-page-header label="Dependents" labelCase="none" />
    <app-table
      [dataSource]="items"
      [pageSize]="5"
      [scrollable]="false"
      [expandable]="true"
      dataKey="hrDependentUid"
      recordLabel="dependent"
      [loading]="loading"
      [error]="error"
    >
      <app-column name="name" label="name" classes="tw-font-bold" />
      <app-column name="dependentSsn" label="dependent ssn">
        <ng-template #value let-data>
          @if (!data.dependentSsn.includes('***')) {
            <app-ssn-label [value]="data.dependentSsn" />
          } @else {
            <span>{{ data.dependentSsn }}</span>
          }
        </ng-template>
      </app-column>
      <app-column name="dateOfBirth" label="Date of Birth" format="d" />
      <app-column name="dependentType" label="dependent Type" />

      <ng-template #expand let-data>
        <div class="tw-flex tw-gap-8 ">
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data" [showEmpty]="true">
              <app-detail-item
                label="Employee SSN"
                name="employeeSsn"
                labelCase="none"
              >
                <ng-template #value>
                  @if (!data.employeeSsn.includes('***')) {
                    <app-ssn-label [value]="data.employeeSsn" />
                  } @else {
                    <span>{{ data.employeeSsn }}</span>
                  }
                </ng-template>
              </app-detail-item>
              <app-detail-item
                label="dependent Beneficiary"
                name="dependentBeneficiary"
              />
              <app-detail-item label="gender" name="gender" />
              <app-detail-item label="address" name="address">
                <ng-template>
                  <app-address-label [street1]="data.street1" />
                </ng-template>
              </app-detail-item>
              <app-detail-item label="home Phone" name="homePhone" format="p" />
              <app-detail-item label="work Phone" name="workPhone" format="p" />
            </app-detail-panel>
          </div>
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data" [showEmpty]="true">
              <app-detail-item
                label="effective Date"
                name="effectiveDate"
                format="d"
              />
              <app-detail-item
                label="expiration Date"
                name="expirationDate"
                format="d"
              />
              <app-detail-item
                label="beneficiary Type"
                name="beneficiaryType"
              />
              <app-detail-item label="dependency" name="dependency" />
            </app-detail-panel>
          </div>
        </div>
      </ng-template>
    </app-table>
  `,
  styles: ``,
})
export class DependentsComponent extends BaseComponent implements OnInit {
  items: HrDependentsResponse[] = [];
  loading = false;
  error: any = null;

  @HandleLoadingState({ useViewLoading: true })
  async ngOnInit() {
    try {
      this.items = await this.api.dependents.dependents(getClaimKey());
    } catch {
      // API may error when no dependents exist; leave items as empty array
    } finally {
      this.view.hideLoading();
    }
  }
}
